var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background-color":"#eeeeee"}},[_c('router-view'),_c('SessionExpiredDialog',{model:{value:(_vm.showSessionExpiredDialog),callback:function ($$v) {_vm.showSessionExpiredDialog=$$v},expression:"showSessionExpiredDialog"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }